export default __webpack_public_path__ + "static/media/LogoFrameWhite.9fbc1336.svg";